import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";

export const getAccessUser = createAsyncThunk('/getAccessUsers',async(data,{rejectWithValue})=>{
     try {
        console.log("testing clinic slice")
        const response = await axios.get('https://dev.api.eclinrecruit.ai/api/user/get-all-users')
        // console.log('getClinicInformation called', response)
        return response.data;
    } catch (error) {
        return rejectWithValue(
            error.response?.data ||
            "Something went wrong while fetching the buyer profile."
        );
    }
})

const initialState = {
    data:[],
    isLoading: true,
    error: null,
}

const getAccessUserSlice = createSlice(
    {
        name: "access-users",
        initialState,
        extraReducers: (builder) => {
            builder.addCase(getAccessUser.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.isLoading = false;
                state.error = null;
            })
                .addCase(getAccessUser.pending, (state) => {
                    state.isLoading = true;
                    state.error = null;
                })
                .addCase(getAccessUser.rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.payload;
                })
        }
    }
)

export default getAccessUserSlice.reducer;